<script setup lang="ts">
const props = defineProps<{
  totalChildren?: number
  small?: boolean
}>()

const { isProductFree } = useEcommerceCatalogue()
const products = useProductVariantsStore()

const { hasAccessWithoutLicence } = useContentAccess(
  props.totalChildren,
  isProductFree(products.activeVariant?.ean ?? ""),
)
</script>

<template>
  <UBadge v-if="hasAccessWithoutLicence" :small="small"
    >Gratis</UBadge
  >
</template>
